import { CheckCircle, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import tigrinho from "@/assets/tigrinho.png";

const before = [
  "Dívidas crescentes e descontrole financeiro",
  "Relacionamentos destruídos pela mentira",
  "Ansiedade e depressão constantes",
  "Perda de tempo e oportunidades",
  "Sentimento de impotência e vergonha",
];

const after = [
  "Controle total sobre suas finanças",
  "Confiança restaurada com família e amigos",
  "Paz mental e autoestima elevada",
  "Foco em objetivos reais e realizáveis",
  "Orgulho de si mesmo e da sua jornada",
];

export const Transformation = () => {
  return (
    <section className="py-20 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/10 rounded-full blur-[120px]" />
      </div>

      <div className="container px-4 relative z-10">
        <div className="text-center mb-16 animate-slide-up">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            A Transformação Que Você{" "}
            <span className="bg-gradient-accent bg-clip-text text-transparent">
              Vai Viver
            </span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Compare sua vida antes e depois do Método LDA
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 max-w-6xl mx-auto items-center">
          {/* ANTES */}
          <div className="space-y-4 animate-slide-in-right">
            <div className="text-center lg:text-right mb-6">
              <h3 className="text-2xl font-bold text-destructive">Antes do LDA</h3>
              <p className="text-muted-foreground">Vivendo no ciclo vicioso</p>
            </div>
            {before.map((item, index) => (
              <div
                key={index}
                className="flex items-start gap-3 lg:flex-row-reverse lg:text-right backdrop-blur-sm bg-card/20 p-4 rounded-lg border border-destructive/20"
              >
                <XCircle className="w-6 h-6 text-destructive flex-shrink-0 mt-0.5" />
                <p className="text-muted-foreground">{item}</p>
              </div>
            ))}
          </div>

          {/* Image Center */}
          <div className="relative animate-scale-in">
            <div className="relative rounded-2xl overflow-hidden">
              {/* <img
                src={transformationImage}
                alt="Transformação - Liberdade"
                className="w-full h-auto"
              /> */}
              <div className="relative z-10">
              <img 
                src={tigrinho} 
                alt="App LDA em dispositivos" 
                className="w-full h-auto drop-shadow-2xl"
              />
              </div>

              
            </div>
            <div className="absolute -inset-4 bg-gradient-radial from-accent/30 via-primary/20 to-transparent blur-3xl -z-10" />
          </div>

          {/* DEPOIS */}
          <div className="space-y-4 animate-slide-in-right" style={{ animationDelay: "0.2s" }}>
            <div className="text-center lg:text-left mb-6">
              <h3 className="text-2xl font-bold text-accent">Depois do LDA</h3>
              <p className="text-muted-foreground">Vivendo com propósito</p>
            </div>
            {after.map((item, index) => (
              <div
                key={index}
                className="flex items-start gap-3 backdrop-blur-sm bg-card/20 p-4 rounded-lg border border-accent/20"
              >
                <CheckCircle className="w-6 h-6 text-accent flex-shrink-0 mt-0.5" />
                <p className="text-muted-foreground">{item}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-16 animate-slide-up" style={{ animationDelay: "0.4s" }}>
          <Button 
            variant="hero" 
            size="xl" 
            className="text-base sm:text-lg"
            onClick={() => {
                    const section = document.getElementById("final-cta");
                    if (section) {
                      section.scrollIntoView({ behavior: "smooth" });
                    }
                  }}
          >
            Começar Minha Transformação
          </Button>
        </div>
      </div>
    </section>
  );
};
